import React from "react";
import { useDispatch } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { Backdrop, Button, InputLabel, Paper, styled, TextField } from "@mui/material";

import { createCollection } from "store/collections/collections-action";
import colors from "theme/themeConstants";
import { ToggleButton } from "components/buttons/ToggleButton";

import cross from "components/icons/cross-black.svg";

interface IProps {
  isOpen: boolean;
  togglePopup: () => void;
}

export const CreateNewCollectionPopup = ({ isOpen, togglePopup }: IProps) => {

  const { control, handleSubmit } = useForm();

  const dispatch = useDispatch();

  const stopPropagation = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  const handleClose = (event: React.MouseEvent) => {
    stopPropagation(event);
    togglePopup();
  };

  const onSubmit = (data: any) => {
    data.published = !data.published;
    dispatch(createCollection({
      ...data
    }));
    togglePopup();
  };

  return (
    <Backdrop open={isOpen} id="create-new-collection-popupOpen"
      sx={{
        zIndex: 31,
      }}
      onClick={handleClose}>
      <Paper
        onClick={stopPropagation}
        sx={{
          maxWidth: "460px",
          width: "90%",
          padding: "2rem 30px",
          borderRadius: "24px",
          zIndex: 22,
          "@media screen and (max-width: 767px)": {
            padding: "2rem 1rem"
          }
        }}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <PopupSubheader >
            <h3>Create a Collection</h3>
            <Button onClick={togglePopup}><img src={cross} alt="close popup" /></Button>
          </PopupSubheader>
          <InputLabel sx={{ fontSize: "12px", fontWeight: 500, fontFamily: "Poppins" }}>Collection name</InputLabel>
          <Controller
            name="folderName"
            control={control}
            defaultValue=""
            rules={{ required: "Required Field!" }}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                sx={{
                  "& div": {
                    borderRadius: "12px",
                    margin: "0.5rem 0",
                    "& input": {
                      padding: "13px 16px",
                      fontSize: "14px"
                    }
                  }
                }}
                fullWidth
                onChange={onChange}
                value={value}
                error={!!error}
              />
            )}
          />
          <InputLabel sx={{ fontSize: "12px", fontWeight: 500, fontFamily: "Poppins" }}>
            Description
          </InputLabel>
          <Controller
            name="description"
            control={control}
            defaultValue=""
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                rows={3}
                multiline
                sx={{
                  "& div": {
                    borderRadius: "12px",
                    margin: "0.5rem 0",
                    "& input": {
                      padding: "13px 16px",
                      fontSize: "14px"
                    }
                  }
                }}
                fullWidth
                onChange={onChange}
                value={value}
                error={!!error}
              />
            )}
          />

          <FlexSwitchContainer>
            <p>Make private</p>
            <Controller
              name="published"
              control={control}
              defaultValue=""
              render={({ field: { onChange, value }, fieldState: { error } }) => (
                <ToggleButton checked={!!value} onChange={onChange}/>
              )}
            />
          </FlexSwitchContainer>

          <Button variant="contained" fullWidth sx={{
            background: colors.purpleGradient,
            marginTop: "2rem",
            minHeight: "3rem",
            borderRadius: "38px",
            fontWeight: 500,
          }} type="submit">
            Create
          </Button>
        </form>
      </Paper>
    </Backdrop>
  );
};

const PopupSubheader = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "2rem",
  "& h3": {
    color: "black !important",
    fontSize: "20px",
    fontWeight: "500",
  },
  "& button": {
    padding: "6px 0",
    minWidth: "32px",
  },
  "& img": {
    width: "32px",
    height: "32px",
  },
});

const FlexSwitchContainer = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  margin: "1rem 0 0 0",
});

